module.exports = __webpack_public_path__ + "img/pending.6baa66ac.svg";